module.exports = __webpack_public_path__ + "img/image_default.25b22228.png";